export default __webpack_public_path__ + "static/media/play.b6809099.svg";